<template>
    <v-card>
		<v-toolbar flat color="grey lighten-4">
		    <v-toolbar-title class="pl-3 grey--text text--darken-4">Distribuzione Trattamenti</v-toolbar-title>
		</v-toolbar>
		<v-divider></v-divider>

		<v-layout v-if="loaded" row wrap px-4 py-2>
			<v-flex xs6 sm6 md3 lg2 py-0 pr-3>
				<v-select 
					:items="fieldsset.year.options"
					v-model="model['year']"
					persistent-hint
					hint="Anno"
					single-line
					dense
					box
				></v-select>
			</v-flex>
		</v-layout>

		<v-data-table class="w100p"
			:items="items"
			:headers="tableHeaders"
			hide-actions>
			<template slot="items" slot-scope="props">
				<tr class="cursor-pointer">
					<template v-for="(header, h) in tableHeaders">
						<td :key="h">
							{{ props.item[header.value] | capitalize }}
						</td>
                        
					</template>
				</tr>
			</template>
		</v-data-table>
	</v-card>
</template>


<script>
	
	import Vue from 'vue'
	
    export default {
        name: 'events-products',
        props: {},
		data() {
			return {
                loaded: false,
                fieldsset: {},
                model: {},
                items: [],
				tableHeaders: [ 
                    {
                        'text': 'Prodotto',
                        'value': 'name'
                    },
                    {
                        'text': 'Categoria',
                        'value': 'category',
                    },
                    {
                        'text': 'Quantità',
                        'value': 'quantity'
                    }
                ],
			}
        },
        watch: {
            model: {
                handler() {
                    this.getData()
                },
                deep: true,
            },
        },
        
        created() {
			this.axios.get('events-products-info').then(response => {
				// get body data
				this.fieldsset = response.data.info.fields
				_.forEach(this.fieldsset, (value, key) => {
				    if(value.default) {
				        Vue.set(this.model, value.key, value.default)
				    }
				})
				this.loaded = true
			}, response => {
				// error callback
			})
		},
		

        
        methods: {
			getData() {
				this.axios.post('events-products', this.model).then(response => {
					this.items = response.data.data
                    
                    this.$store.commit('endProgress')

				}, response => {
					// error callback
				})
            },
        },
    }
</script>
